import React, { Component } from 'react';

import RadioGroup from '../../../components/common/elements/RadioGroup';
import { USER_ROLES, USER_ROLE_NAMES } from '../../../config/constants';
import translator from '../../../components/localization/translator';
import './userDetails.css';

export default class RadioField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role: this.props.userDetails.user.role
        }
    }

    isDisabled(role) {
        if (!this.props.isNew) {
            const isDistributerSelected = this.state.role === USER_ROLES.DISTRIBUTOR;
            const isDistributor = role === USER_ROLES.DISTRIBUTOR;
            if (isDistributerSelected) {
                if (isDistributor) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (isDistributor) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    }

    renderRadioGroup(data, index) {
        const roles = [USER_ROLES.CUSTOMER, USER_ROLES.SERVER];
        if (roles.indexOf(data.role) !== -1) {
            return null;
        }
        return (
            <RadioGroup
                id={`userRole-${index}`}
                name={'userRole'}
                key={index}
                title={translator.translate(data.label)}
                value={data.role}
                checked={data.role === this.state.role}
                onClick={(e) => {
                    this.setState({
                        role: Number(e.target.value)
                    });
                    this.props.changeRole(Number(e.target.value));
                }}
                disabled={this.isDisabled(data.role)}
                customClass="margin-to-right"
                customRadioClass="to-right"
                customRadioSpanClass="inline-block" />
        )
    }

    render() {
        return(
            <div className='display-flex'>
                <label className={'label-width'}>{translator.translate('_roles_')}</label>
                <div className='my-custom-input margin-to-left'>
                    {USER_ROLE_NAMES.filter(userRole => userRole.role !== USER_ROLES.B2B_USER).map(this.renderRadioGroup.bind(this))}
                </div>
            </div>

        );
    }
}
